import React from 'react';
import bem from 'utils/bem';
import Text from 'components/Text';
import { IconButton } from 'components/Button';
import { Skeleton } from '@mui/material';
import { formatNumber } from 'utils/format';
import Model from '../../../../model';
import './index.sass';

const { block, el } = bem('mobile-card-teaser');

export const MobileCardTeaser = ({ card, color }) => {
    const { id, nominalRub } = card;

    const { openPaymentCardForm } = Model.modal;

    const openCardFormWithPrice = () => {
        openPaymentCardForm({ price: nominalRub, cardId: id });
    }

    return (
        <div className={ block('mobile') } style={{'--bg-color': color}} onClick={openCardFormWithPrice}>
            <div className={ el('nominal') }>
                <div className={ el('price') }><Text serif>{ formatNumber(nominalRub) }</Text></div>
                <span>&nbsp;</span>
                <div className={ el('rubles') }><Text>рублей</Text></div>
            </div>
            <div className={ el('button') }>
                <IconButton mod={ 'gold' } name={'shopping-cart'}/>
            </div>
        </div>
    )
}

export const MobileCardTeaserSkeleton = () => {
    return (
        <div className={ block() }>
            <Skeleton variant={ 'rounded' } style={ { borderRadius: '10px' } }/>
        </div>
    )
}

export default MobileCardTeaser;
